var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile",class:_vm.tileClass,style:(_vm.tileStyle)},[(_vm.hasTreasure)?_c('div',{staticClass:"treasure-icon",style:(_vm.treasureStyle)}):_vm._e(),(_vm.isConflictTile)?_c('div',{staticClass:"conflict-tile text-dark bg-warning"},[_c('b-icon',{staticClass:"w-100 h-100 light",attrs:{"icon":"x-square"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }